module.exports = "/_next/static/images/block3_mobile-25aeefd53012326245468aaef979f8a1.svg";